import { useLanguage } from "@/contexts/LanguageContext";

const AboutSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 lg:py-32 bg-white dark:bg-card" id="about">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground dark:text-foreground text-gray-900 mb-8 tracking-tight">
            {t("ABOUT US", "من نحن")}
          </h2>
          <div className="space-y-6 text-lg lg:text-xl text-gray-600 dark:text-muted-foreground leading-relaxed">
            <p>
              {t(
                "Digital Bridge is a full-service agency with a global vision helping their clients bridging the gap between where they are to where they want to be by digitalization.",
                "ديجيتال بريدج هي وكالة متكاملة الخدمات ذات رؤية عالمية تساعد عملاءها على سد الفجوة بين موقعهم الحالي والمكان الذي يريدون الوصول إليه من خلال التحول الرقمي."
              )}
            </p>
            <p>
              {t(
                "Building a solid digital infrastructure is the ultimate goal which helps to overcome economical changes.",
                "بناء بنية تحتية رقمية متينة هو الهدف الأسمى الذي يساعد على التغلب على التغيرات الاقتصادية."
              )}
            </p>
            <p>
              {t(
                "Our methodology accelerates achieving business purposes standing on main pillars which are",
                "منهجيتنا تسرّع تحقيق أهداف الأعمال بالاعتماد على ركائز أساسية وهي"
              )}{" "}
              <span className="text-primary font-semibold">{t("strategy", "الاستراتيجية")}</span>،{" "}
              <span className="text-primary font-semibold">{t("creativity", "الإبداع")}</span>{" "}
              {t("and", "و")}{" "}
              <span className="text-primary font-semibold">{t("media", "الإعلام")}</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
